import AddElementLayout from "../layouts/AddElementLayout";
import * as Yup from 'yup';
import { postData, updateData } from "../../helpers/api";
import { openNotification } from "../../helpers/alerts";
import { phoneRegExp } from "../../constants/others";

import moment from 'moment';
import FormInputs from "./FormInputs";
const AddOrder = (props) => {
    const {
        handleAfterAddingOrder,
        initialValue,
        isModalOpen,
        handleCancel,
    } = props

    const saveOrder = async (values, submitProps) => {
        try {
            values.orderDate = moment(values.orderDate).format('YYYY-MM-DD')
            if (values.id) {
                await updateData("/orders", values)
                openNotification(`La commande a été mis a jour avec succès`, 'success')
            }
            else {
                await postData("/orders", values)
                openNotification(`La commande a été ajouter avec succès`, 'success')
            }
            submitProps.resetForm()
            handleAfterAddingOrder()
        } catch (error) {
            if (error.status === 400) {
                openNotification(`Erreur du côté du BMD, veuillez vérifier vos données`, 'error')
                return;
            }
            if (error.status === 403) {
                openNotification(`Vous n'êtes pas autorisé à créer des commandes avec ces produits`, 'error')
                return;
            }
            openNotification(`Erreurs côté serveur`, 'error')
        }
    }
    return (
        <AddElementLayout
            title={initialValue.id ? "Mis a jour la commande" : "Ajouter une commande"}
            isModalOpen={isModalOpen}
            handleCancel={handleCancel}
            initialValue={initialValue}
            width={800}
            validationSchema={Yup.object({
                name: Yup.string().required('required'),
                address: Yup.string().required('required'),
                phone: Yup.string()
                    .required('required').matches(phoneRegExp, 'Le numéro de téléphone doit commencer par 06 ou 07 et comporter 10 chiffres.'),
                price: Yup.number().required('required'),
                confimationStatus: Yup.string().required('required'),
                bmdCity: Yup.string().required('required'),
                orderDate: Yup.date().required("required"),
                orders: Yup.array().of(
                    Yup.object().shape({
                        product: Yup.string().required('required'),
                        unit: Yup.number().required('required'),
                    })
                ),
                deliveryCompany: Yup.string().required('required'),
                deliveryCompanyKey: Yup.string().required('required'),
                content: Yup.string().optional()
            })}
            handleSubmitForm={(values, submitProps) => {
                saveOrder(values, submitProps)
                console.log(values)
            }}
        >
            <FormInputs
                initialValue={initialValue}
            />
        </AddElementLayout >
    );
}

export default AddOrder;